import { getLocalizedMessage } from "@pimo/pimo-l10n";

export type CardCopyKey =
  | "managementSummary"
  | "dashboardTitle"
  | "overviewTitle"
  | "overviewProjectsTable"
  | "reportTitle"
  | "reportTrackingItemsTitle"
  | "reportOverallStatus"
  | "reportManagementSummary"
  | "reportCategory"
  | "reportCompletion"
  | "reportNumberOfItems"
  | "reportNumberOfCompletedItems"
  | "reportDueItems"
  | "overallStatus"
  | "numberOfItems"
  | "numberOfCompletedItems"
  | "numberOfProjects"
  | "numberOfCompletedProjects"
  | "dueItems"
  | "dueProjects"
  | "statusOfProjects"
  | "projectStatusCounts"
  | "statusOfItems"
  | "reportItemStatusDistribution"
  | "reportItemStatusCounts"
  | "itemStatusCounts"
  | "completionOfProjects"
  | "projectCompletionCounts"
  | "completionOfItems"
  | "reportTrackingItemsTable"
  | "reportItemCompletionDistribution"
  | "reportItemCompletionCounts"
  | "itemCompletionCounts"
  | "completedProjectsByCategory"
  | "completedItemsByCategory"
  | "completedItemsByCategoryLevel"
  | "completedItemsByCategoryLevelPerProject"
  | "reportCompletedItemsOverTime"
  | "reportCompletedItemsOverTimeCumulative"
  | "completedItemsOverTime"
  | "completedItemsOverTimeCumulative"
  | "completedProjectsOverTime"
  | "completedProjectsOverTimeCumulative";

export type CardCopyParams = {
  itemName?: string;
  itemNamePlural?: string;
  projectName?: string;
  projectNamePlural?: string;
  categoryLabel?: string;
  projectLabel?: string;
};

export function getLocalizedCardCopy(
  language: string,
  key: CardCopyKey,
  params: CardCopyParams = {}
) {
  return {
    title: getLocalizedMessage(language, `cards.${key}.title`, params),
    description: getLocalizedMessage(
      language,
      `cards.${key}.description`,
      params
    ),
  };
}
